import { useRef, useState } from 'react';
import { Box } from '@mui/material';
import { pushEvent } from '../../../../utils/dataLayer';

import useTopCoupons from '../../../../hooks/useTopCoupons';
import useCouponRedirect from '../../../../hooks/useCouponRedirect';
import useUTMParams from '../../../../hooks/useUTMParams';
import useUserData from '../../../../hooks/useUserData';
import { useAuth } from '../../../../context/AuthContext';
import { useAlert } from '../../../../context/AlertContext';
import { useTopCouponStoreRoute } from '../../../../hooks/useTopCouponStoreRoute';

import CouponCard, { getCashbackPercentage } from '../../../../components/Coupons/CouponCard';
import Cupom from '../../../../components/Modal/Cupom/Cupom';

import {
    TitleTopCupons,
    TopCouponList,
    ButtonWrapper,
    Button,
    Divider
} from './Styled';

const TopCupons = () => {
    const couponListRef = useRef(null);
    const [page] = useState(1);
    const [limit] = useState(12);

    const { coupons } = useTopCoupons({ page, limit });
    const { isAuthenticated } = useAuth();
    const { getcouponRedirect } = useCouponRedirect();
    const { utmSource, utmCampaign } = useUTMParams();
    const { user } = useUserData();
    const { showAlert } = useAlert();

    const { selectedCoupon, isModalOpen, openCoupon, closeCoupon } = useTopCouponStoreRoute(coupons);

    const renderedCoupons = (coupons || [])
        .filter((coupon) => coupon?.store)
        .map((coupon) => {
            const categorie = coupon.hotArea || {};

            return (
                <CouponCard
                    key={coupon.id}
                    coupon={coupon}
                    categorie={categorie}
                    isAuthenticated={isAuthenticated}
                    openCoupon={openCoupon}
                    getcouponRedirect={getcouponRedirect}
                    utmSource={utmSource}
                    utmCampaign={utmCampaign}
                    userId={user?.id}
                    incentiveId={categorie?.incentive_id}
                    showAlert={showAlert}
                />
            );
        });

    return (
        <Box>
        <Divider />
        <TitleTopCupons>Melhores Cupons e Ofertas</TitleTopCupons>

        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <TopCouponList style={{ alignItems: 'center', justifyContent: 'center' }} ref={couponListRef}>
            {renderedCoupons}
            </TopCouponList>

            {coupons.length === 12 && (
            <ButtonWrapper>
                <Button onClick={() => { pushEvent('home.showmore.click'); window.location.href = '/top-cupons'; }}>
                Ver mais
                </Button>
            </ButtonWrapper>
            )}
        </Box>

        {isModalOpen && selectedCoupon && (
            <Cupom
            open={isModalOpen}
            handleClose={closeCoupon}
            couponId={selectedCoupon.id}
            name={selectedCoupon.name}
            slug={selectedCoupon.slug}
            cupomLink={selectedCoupon.linkUrl}
            cupomCode={selectedCoupon.code}
            description={selectedCoupon.description}
            clicks={selectedCoupon.clicks}
            endDate={selectedCoupon.endDate}
            storeName={selectedCoupon.store?.name}
            storeSlug={selectedCoupon.store?.slug}
            cashback={getCashbackPercentage(selectedCoupon.store, selectedCoupon.hotArea)}
            incentiveId={selectedCoupon.hotArea?.incentive_id}
            userId={user?.id}
            />
        )}
        </Box>
    );
};

export default TopCupons;

